export const datacenter_marks = [
    { label: '1', value: 1 },
    { label: '', value: 2 },
    { label: '', value: 3 },
    { label: '', value: 4 },
    { label: '', value: 5 },
    { label: '', value: 6 },
    { label: '', value: 7 },
    { label: '', value: 8 },
    { label: '', value: 9 },
    { label: '', value: 10 },
    { label: '', value: 20 },
    { label: '', value: 30 },
    { label: '', value: 40 },
    { label: '50', value: 50 },
    { label: '', value: 75 },
    { label: '100', value: 100 },
    { label: '', value: 125 },
    { label: '150', value: 150 },
    { label: '', value: 175 },
    { label: '200', value: 200 },
    { label: '', value: 225 },
    { label: '250', value: 250 },
    { label: '300', value: 300 },
    { label: '350', value: 350 },
    { label: '400', value: 400 },
    { label: '450', value: 450 },
    { label: '500', value: 500 },
    { label: '600', value: 600 },
    { label: '700', value: 700 },
    { label: '800', value: 800 },
    { label: '900', value: 900 },
    { label: '1000', value: 1000 },
];

export const residential_marks = [
    { label: '1 GB', value: 1, realValue: 1 },
    { label: '2 GB', value: 2, realValue: 2 },
    { label: '5 GB', value: 3, realValue: 5 },
    { label: '10 GB', value: 4, realValue: 10 },
    { label: '25 GB', value: 5, realValue: 25 },
    { label: '50 GB', value: 6, realValue: 50 },
    { label: '100 GB', value: 7, realValue: 100 },
    { label: '250 GB', value: 8, realValue: 250 },
    { label: '500 GB', value: 9, realValue: 500 },
    { label: '1 TB', value: 10, realValue: 1000 },
    { label: '1.5 TB', value: 11, realValue: 1500 },
    { label: '2 TB', value: 12, realValue: 2000 },
    { label: '3 TB', value: 13, realValue: 3000 },
    { label: '4 TB', value: 14, realValue: 4000 },
    { label: '5 TB', value: 15, realValue: 5000 },
];

export const getTarrifName = (interval, count) => {
    if (interval === 'month' && count === 1) return 'Mountly';
    if (interval === 'month' && count === 3) return 'Quarterly';
    if (interval === 'year' && count === 1) return 'Annually';
};

export const convertToCent = (value = 0) => Number((value / 100).toFixed(2));

export const getPriceTierAmount = (value, data) => {
    for (let i = 0; i < data?.length; i++) {
        const tier = data[i];

        if (tier.price_tier_up_to === null || value <= tier.price_tier_up_to) {
            return tier.price_tier_amount;
        }
    }

    // В случае, если value превышает все уровни цен, можно вернуть значение по умолчанию или бросить ошибку.
    // Например, вернем значение последнего уровня цен.
    return data[data?.length - 1]?.price_tier_amount;
};
